import { useParams } from 'react-router';

export const useInboxItemParamId = () => {
  const { inboxItemId } = useParams<{ inboxItemId: string }>();
  return inboxItemId;
};
